module.exports = __webpack_public_path__ + "static/assets/385a3db57123e911b9bc76894a5d1ae5.png";